export const GET_FREELANCER_DOCUMENTS_SUMMARY = 'GET_FREELANCER_DOCUMENTS_SUMMARY';
